import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSearchTerm } from "../../redux/slices/messagesSlice";
const ChatHistoryHeader = ({ userChatWith }) => {
  const dispatch = useDispatch();
  const [isSearching, setIsSearching] = useState(false);
  const inputRef = useRef(null);
  const toggleSearching = () => {
    setIsSearching(!isSearching);
  };
  useEffect(() => {
    if (isSearching) {
      inputRef.current.focus();
    }
  }, [isSearching]);
  const { searchTerm } = useSelector((state) => state.messages);
  return (
    <div className="card-header border-0">
      <div className="msg_head">
        <div className="d-flex bd-highlight align-items-center">
          <a
            id="back_user_list"
            href="javascript:void(0)"
            className="back-user-list"
          >
            <i className="fas fa-chevron-left"></i>
          </a>
          <div className="avatar avatar-lg online flex-shrink-0 me-2">
            <img src={userChatWith.imageUrl} alt="User" />
          </div>
          <div>
            <h6 className="fs-16 fw-medium mb-1">{userChatWith.fullName}</h6>
            <p className="fs-14">Online</p>
          </div>
        </div>
        <div className="d-flex align-items-center send-action">
          <a
            href="#"
            className="btn chat-search-btn send-action-btn"
            data-bs-toggle="tooltip"
            data-bs-placement="bottom"
            title="Search"
            onClick={(e) => {
              e.preventDefault();
              toggleSearching();
            }}
          >
            <i className="isax isax-search-normal-14"></i>
          </a>
          <a
            className="btn no-bg send-action-btn rounded-circle"
            href="#"
            data-bs-toggle="dropdown"
          >
            <i className="ti ti-dots-vertical"></i>
          </a>
          <ul className="dropdown-menu dropdown-menu-end p-3">
            <li>
              <a href="#" className="dropdown-item">
                <i className="isax isax-close-circle me-2"></i>Close Chat
              </a>
            </li>
            <li>
              <a href="#" className="dropdown-item">
                <i className="fa-solid fa-volume-xmark me-2"></i>Mute
                Notification
              </a>
            </li>
            <li>
              <a href="#" className="dropdown-item">
                <i className="isax isax-clock me-2"></i>Disappearing Message
              </a>
            </li>
            <li>
              <a href="#" className="dropdown-item">
                <i className="isax isax-refresh me-2"></i>Clear Message
              </a>
            </li>
            <li>
              <a href="#" className="dropdown-item">
                <i className="isax isax-trash me-2"></i>Delete Chat
              </a>
            </li>
            <li>
              <a href="#" className="dropdown-item">
                <i className="fa-regular fa-thumbs-down me-2"></i>Report
              </a>
            </li>
            <li>
              <a href="#" className="dropdown-item">
                <i className="fa-solid fa-ban me-2"></i>Block
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div
        className={`chat-search search-wrap contact-search ${
          isSearching ? "visible-chat" : ""
        } `}
      >
        <form>
          <div className="input-group">
            <input
              type="text"
              className="form-control"
              placeholder="Search Contacts"
              value={searchTerm}
              onChange={(e) => dispatch(setSearchTerm(e.target.value))} // 🚀 Dispatch giá trị tìm kiếm
              ref={inputRef}
            />
            <span className="input-group-text" style={{ cursor: "pointer" }}>
              <i className="isax isax-search-normal-14"></i>
            </span>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChatHistoryHeader;
